import { FC } from 'react';
import { Activity, ActivityType } from '../../graphql/generated/graphql.ts';
import { DeepPartial } from '@apollo/client/utilities';
import { Avatar, Breadcrumbs, Card, CardContent, Stack, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { trackEvent } from '../../utils/analytics.ts';

const renderType = (type: ActivityType) => {
  switch (type) {
    case ActivityType.Pleasant:
      return 'Pleasant';
    case ActivityType.Meaningful:
      return 'Meaningful / Challenging';
    case ActivityType.Social:
      return 'Social Connection';
  }
};

export interface ActivityDisplayProps {
  activity?: DeepPartial<Activity>;
  day: string;
  period: string;
}

export const ActivityDisplay: FC<ActivityDisplayProps> = ({ activity, day, period }) => {
  const navigate = useNavigate();
  const handleEdit = (activityId: string) => {
    navigate(`/activity/${activityId}`);
    trackEvent('activity_edit_open', { activityId });
  };

  if (!activity) {
    return null;
  }
  return (
    <Card
      sx={{
        borderLeft: `10px solid ${activity?.domain?.color}`,
        borderRadius: 3
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
          {activity?.domain?.iconUrl && <Avatar src={activity?.domain?.iconUrl} />}
          <Stack>
            <Typography variant="h6">{activity?.description}</Typography>
            {activity?.subgoal && <Typography variant="subtitle1">Sub Goal: {activity.subgoal}</Typography>}
            <Breadcrumbs separator="•">
              <Typography variant="subtitle1">{activity?.domain?.title}</Typography>
              {activity?.type && <Typography variant="subtitle1">{renderType(activity.type)}</Typography>}
            </Breadcrumbs>
            <Breadcrumbs separator="•">
              <Typography variant="subtitle1">{day}</Typography>
              <Typography variant="subtitle1">{period}</Typography>
            </Breadcrumbs>
          </Stack>
          <IconButton onClick={() => handleEdit(activity._id as string)} edge="start">
            <EditIcon />
          </IconButton>
        </Stack>
      </CardContent>
    </Card>
  );
};
